<div class="chip-container" (click)="chipClicked()">
  <div class="chip {{ chip.active ? 'active' : '' }}">
    <span class="label">
      {{ 'filter.' + chip.name | translate }}
      <span *ngIf="chip.quantity"> ({{ chip.quantity }}) </span>
    </span>
  </div>
</div>
